import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searcht'
})
export class SearchPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value) return null;
    if(!args) return value;

    // args = args.toLowercase();
    // debugger;
    
    return value.filter(function(item){
      // console.log(item.DCNumber);
      return JSON.stringify(item).includes(args);
    })
  }

}